const getScrollParent = (el: HTMLElement | null): HTMLElement | null => {
  let parent = el?.parentElement ?? null

  while (parent) {
    const style = window.getComputedStyle(parent)
    const overflowY = style.overflowY

    const canScrollY =
      overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay'

    if (canScrollY && parent.scrollHeight > parent.clientHeight) return parent

    parent = parent.parentElement
  }

  return null
}

export default getScrollParent
